import clsx from 'clsx';
import { ContainerBase } from '../containers/containerBase';
import { Title } from '../title';
import { Button } from '@/components/common';
import { Category } from '@/interfaces';
import { CardCaseType } from './CardCaseType';
import AppRoutes from '@/const/routes';
import { CarouselComponent } from './CarouselComponent';
import { SwiperSlide } from 'swiper/react';

export const CaseTypes: React.FC = () => {
	const categories: Category[] = [
		'Securities',
		'Antitrust',
		'Health Care',
		'Commodities',
		'Consumer Protection',
		'Data Privacy',
	];

	return (
		<div className="relative w-full lg:px-[78px] mt-14 lg:mt-0">
			<ContainerBase
				className={clsx(
					'lg:space-y-16 pb-12 md:pb-16 lg:pt-28 relative',
					'flex flex-col items-center w-full'
				)}
			>
				<Title
					className="lg:max-w-[578px] xl:max-w-[768px]"
					description="Our platform empowers our clients to sign up, monitor, and engage with attorneys seamless."
				>
					Case types
				</Title>
				{/* Desktop */}
				<div className="hidden lg:grid lg:grid-cols-2 xl:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
					{categories.map((category, index) => (
						<CardCaseType key={index} category={category} />
					))}
				</div>
				{/* Mobile */}
				<div className="max-w-full overflow-hidden lg:hidden">
					<CarouselComponent id="case-types" amountPages={categories.length}>
						{categories.map((category, index) => (
							<SwiperSlide key={index}>
								<CardCaseType category={category} />
							</SwiperSlide>
						))}
					</CarouselComponent>
				</div>
				<Button
					decoration="primary"
					size="medium"
					href={AppRoutes.LANDING_CASES}
				>
					Explore All Cases
				</Button>
			</ContainerBase>
		</div>
	);
};
